import { render, staticRenderFns } from "./ShipmentReceived.vue?vue&type=template&id=c440cf04&scoped=true&"
import script from "./ShipmentReceived.vue?vue&type=script&lang=js&"
export * from "./ShipmentReceived.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentReceived.vue?vue&type=style&index=0&id=c440cf04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c440cf04",
  null
  
)

export default component.exports